import Button from '@blocks/Button'
import Footer from '@blocks/Footer'
import Grid from '@blocks/Grid'
import Logo from '@blocks/Logo'
import { Container } from '@styles/helpers'
import useSalonController from '@general/api/useSalonController'
import useSalon from '@general/models/Salon'
import { route } from '@helpers'
import useTitle from '@hooks/useTitle'
import { ReactComponent as LeftIcon } from '@icons/left.svg'
import { desktop, mTablet } from '@styles/mixins'
import React from 'react'
import { useParams } from 'react-router'
import styled, { css } from 'styled-components'
import SalonGallerySections from './components/Sections/SalonGallerySections'
import SalonGalleryContext, { useSalonGalleryContext } from './context'

export default function SalonGalleryPage() {
    const { slug } = useParams<{ slug: string }>()
    const salon = useSalon(slug)

    const controller = useSalonController()
    const gallery = controller.gallery(slug).use()

    const name = salon.state?.name || "Loading..."
    useTitle(`Gallery: ${name}`)

    if (!salon.state)
        return null

    return (
        <SalonGalleryContext.Provider value={{ salon, gallery } as General.Contexts.SalonGallery}>
            <ComponentContainer>
                <Grid gap="30px|60px">
                    <ComponentHeader>
                        <ComponentHeaderLogo>
                            <Logo />
                        </ComponentHeaderLogo>
                        <ComponentHeaderBack>
                            <Button type="tertiary" to={route("general:salon", slug)} icon={<LeftIcon />}>Results</Button>
                        </ComponentHeaderBack>
                        <ComponentHeaderTitle>
                            <Grid gap="10px">
                                <h1>{salon.state.name}</h1>
                                <h2 className="h4">Gallery</h2>
                            </Grid>
                        </ComponentHeaderTitle>
                    </ComponentHeader>
                    <hr />
                    <SalonGallerySections />
                </Grid>
            </ComponentContainer>
            <Footer />
        </SalonGalleryContext.Provider>
    )
}

const ComponentContainer = styled(Container)`
    padding-top: 30px;
    padding-bottom: 30px;
`

const ComponentHeader = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(2, auto);
    grid-gap: 20px;
    grid-template-areas:
        "back logo"
        "title title";

    ${mTablet(css`
        grid-template-columns: 1fr minmax(auto, 75%) 1fr;
        grid-template-areas:
            ". logo ."
            "back title .";
    `)}

    ${desktop(css`
        grid-template-columns: 1fr minmax(auto, 50%) 1fr;
    `)}
`

const ComponentHeaderBack = styled.div`
    grid-area: back;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`

const ComponentHeaderTitle = styled.div`
    grid-area: title;
    display: flex;
    justify-content: center;
    align-items: center;

    ${mTablet(css`
        text-align: center;
    `)}
`

const ComponentHeaderLogo = styled.div`
    grid-area: logo;
    display: flex;
    justify-content: flex-end;

    ${mTablet(css`
        justify-content: center;
    `)}
`